<ion-content>
  <div class="error">
    <ion-icon class="error__icon" name="warning"></ion-icon>
    <span class="error__text" id="error_textHeader">
      {{ 'ERROR_VERSION.ERROR_HEADER' | translate }}
    </span>
  </div>

  <div class="button">
    <ion-button class="error__button-home" [href]="android">
      <a id="androidUpdateText" class="textButton">
        {{ 'ERROR_VERSION.ANDROID_UPDATE' | translate }}
      </a>
    </ion-button>
  </div>

</ion-content>